module.exports = __webpack_public_path__ + "static/img/australia_a_league.583e001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/australia_a_league.jpg
// module id = 89Eo
// module chunks = 1